import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import {
  Filtering,
  QBox,
  QSelect,
  QSelectItem,
  useCurrentUser,
} from '@qualio/ui-components';

export const FOR_TRAINING_FILTER = 'for_training';
export const ALL_DOCS_FILTER = 'all_docs';

export const TrainingFilter = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();

  const trainingFilterOptions: QSelectItem[] = [
    {
      label: t('labels.allDocuments'),
      value: ALL_DOCS_FILTER,
    },
    {
      label: t('labels.trainingDocuments'),
      value: FOR_TRAINING_FILTER,
    },
  ];
  const [searchParams] = useSearchParams();
  const filterBy = searchParams.get('filter_by') ?? undefined;
  const [trainingFilter, setTrainingFilter] = useState<string | undefined>(
    filterBy,
  );
  const filtering = Filtering.useFiltering();

  const onTrainingFilterChange = (option: QSelectItem | null) => {
    if (option !== null) {
      setTrainingFilter(option.value);
      filtering.setFilters({ filter_by: option.value });
    }
  };

  if (currentUser.permissions.can_view_workspace) {
    return null;
  }

  return (
    <QBox width={'25%'} data-cy="training-filter">
      <QSelect
        size="sm"
        options={trainingFilterOptions}
        onChange={onTrainingFilterChange}
        value={trainingFilter}
        inputId="training-filter-input"
        aria-label={t('accessibilityLabels.trainingFilterAriaLabel')}
      />
    </QBox>
  );
};
